import type { OpenPositionBranchAggregate } from "@/common/api/open-position/use-open-position-branch-aggregate-search.query";
import { ImplementedAccessorColumnDef } from "@/components/data-table/types";
import { EmptyValue } from "@/components/ui/empty-value";
import i18next from "i18next";
import { createAggregateMetricColumns } from "./aggregate-metric-columns";

export type BranchAggregateRow = OpenPositionBranchAggregate & { uuid: string };

const BRANCHLESS_AGGREGATE_ROW_UUID = "no-branch";

export const toBranchAggregateRow = (aggregate: OpenPositionBranchAggregate): BranchAggregateRow => ({
  ...aggregate,
  uuid: aggregate.branch?.uuid ?? BRANCHLESS_AGGREGATE_ROW_UUID,
});

const metricColumns = createAggregateMetricColumns<BranchAggregateRow>();

export const branchAggregateColumns = {
  name: {
    id: "name",
    size: 260,
    enableSorting: true,
    header: () => i18next.t("fia:Branch"),
    accessorFn: (row: BranchAggregateRow) => row.branch ?? null,
    cell: (info) => info.getValue()?.name || <EmptyValue />,
  } as ImplementedAccessorColumnDef<BranchAggregateRow, BranchAggregateRow["branch"]>,
  ...metricColumns,
};
